const locale = "zh-CN";
const translations = {
	timeFormat: "HH:mm",
	dateFormat: "YYYY-MM-DD",
	dateTimeFormat: "YYYY-MM-DD HH:mm",
	"serviceReports.headline": "服务报告",
	"serviceReports.sublineMachine": "查看您机床的服务报告并下载。",
	"serviceReports.technicianName": "服务工程师姓名",
	"serviceReports.machineNameAndNumber": "机床及机床编号",
	"serviceReports.startDate": "从",
	"serviceReports.endDate": "至",
	"serviceReports.creationDate": "创建日期",
	"serviceReports.openReport": "打开服务报告（PDF）",
	"serviceReports.filter": "筛选",
	"serviceReports.missionNumber": "任务编号",
	"serviceReports.assignmentType": "服务报告类型",
	"serviceReports.reportTypes.IA": "拆卸/转换报告",
	"serviceReports.reportTypes.AC": "应用咨询报告",
	"serviceReports.reportTypes.IV": "安装准备报告",
	"serviceReports.reportTypes.BA": "现状评估报告",
	"serviceReports.reportTypes.UV": "安全检查报告",
	"serviceReports.reportTypes.IG": "二手机安装报告",
	"serviceReports.reportTypes.UB": "质量措施报告",
	"serviceReports.reportTypes.PN": "生产支持报告",
	"serviceReports.reportTypes.NR": "功能扩展报告",
	"serviceReports.reportTypes.IB": "安装/启动报告",
	"serviceReports.reportTypes.II": "安装集成报告",
	"serviceReports.reportTypes.IC": "内部修复报告",
	"serviceReports.reportTypes.MB": "展会支持报告",
	"serviceReports.reportTypes.HW": "资源报告",
	"serviceReports.reportTypes.TT": "技术员培训报告",
	"serviceReports.reportTypes.SK": "客户培训报告",
	"serviceReports.reportTypes.RP": "修复报告",
	"serviceReports.reportTypes.RW": "修复和保养报告",
	"serviceReports.reportTypes.WA": "保养报告",
	"serviceReports.reportTypesPlural.IA": "拆卸/转换报告",
	"serviceReports.reportTypesPlural.AC": "应用咨询报告",
	"serviceReports.reportTypesPlural.IV": "安装准备报告",
	"serviceReports.reportTypesPlural.BA": "现状评估报告",
	"serviceReports.reportTypesPlural.UV": "安全检查报告",
	"serviceReports.reportTypesPlural.IG": "二手机安装报告",
	"serviceReports.reportTypesPlural.UB": "质量措施报告",
	"serviceReports.reportTypesPlural.PN": "生产支持报告",
	"serviceReports.reportTypesPlural.NR": "功能扩展报告",
	"serviceReports.reportTypesPlural.IB": "安装/启动报告",
	"serviceReports.reportTypesPlural.II": "安装集成报告",
	"serviceReports.reportTypesPlural.IC": "内部修复报告",
	"serviceReports.reportTypesPlural.MB": "展会支持报告",
	"serviceReports.reportTypesPlural.HW": "资源报告",
	"serviceReports.reportTypesPlural.TT": "技术员培训报告",
	"serviceReports.reportTypesPlural.SK": "客户培训报告",
	"serviceReports.reportTypesPlural.RP": "修复报告",
	"serviceReports.reportTypesPlural.RW": "修复与保养报告",
	"serviceReports.reportTypesPlural.WA": "保养报告",
	"serviceReports.loadMore": "加载更多",
	"serviceReports.loadError": "加载数据时出错",
	"serviceReports.noReportsFound": "当前无服务报告可用。",
	"serviceReports.noReportsAvailable": "当前无服务报告可用。",
	missingAuthorization: "缺少权限",
	"headline.createCase": "创建新的服务案例",
	"headline.caseDetails": "案例详情",
	"headline.contactData": "联系方式",
	"field.reason.label": "报告原因",
	"field.machine.label": "机床及机床编号",
	"field.softwareProblemClassification.label": "问题类别",
	"field.softwareInstallationProblem.label": "安装问题",
	"field.softwareLicenseIssue.label": "许可证问题",
	"field.softwareType.label": "软件类型",
	"field.softwareModule.label": "软件模块",
	"field.errorNumber.label": "故障编号",
	"field.errorNumber.explanation": "例如 0000FC00、1.10.58102409 或 6000",
	"field.errorNumber.addAnotherNumber": "添加其它故障编号",
	"field.errorNumber.errorMessage": "无效的故障编号",
	"field.message.label": "消息",
	"field.message.placeholder": "请尽可能准确且详实描述（无需问候）您的关切/问题。 非常感谢。",
	"field.fileUpload.label": "附件",
	"field.fileUpload.info": "允许的文件格式：IMG、JPG、PNG、PDF、HTML、TruTops 文件等（不超过 16 MB）以及 MP4 视频文件（不超过 50 MB）",
	"field.salutation.label": "称呼",
	"field.salutation.male": "先生",
	"field.salutation.female": "女士",
	"field.firstName.label": "名",
	"field.lastName.label": "姓",
	"field.email.label": "电子邮件",
	"field.phone.label": "电话号码",
	"button.submit": "发送",
	"button.cancel": "取消",
	"button.back": "返回",
	"button.next": "继续",
	"button.close": "关闭",
	"button.ok": "OK",
	"auth.error": "出现未知错误。",
	"select.placeholder": "请选择…",
	"validation.requiredField": "此栏为必填项",
	"validation.invalidEmail": "请输入有效的电子邮件地址",
	"validation.maxAllowedCharacters": "最多允许的字符数：{{number}}",
	"validation.requiredFieldsExplanation": "必填项标有 *。",
	"validation.invalidPhoneNumber": "请输入有效的电话号码。",
	"softwareProblemClassification.standstill": "停机",
	"softwareProblemClassification.fault": "故障",
	"softwareProblemClassification.slightImpairment": "轻微损伤",
	"softwareProblemClassification.generalInquiry": "一般询价",
	"serviceCase.proactiveCaseClosure.title": "反馈与案例关闭申请",
	"serviceCase.proactiveCaseClosure.instructions": "为申请案件关闭并帮助我们改进预测性服务，我们诚邀您提供反馈。",
	"serviceCase.proactiveCaseClosure.question.submit": "发送",
	"serviceCase.proactiveCaseClosure.dialogTitle": "已申请结案。感谢您的反馈。",
	"serviceCase.proactiveCaseClosure.dialog.buttonOk": "OK",
	"serviceCase.proactiveCaseClosure.question.anomaly": "您的机床是否确实存在所登记的异常？",
	"serviceCase.proactiveCaseClosure.question.technicalGuideLinked": "Technical Guide 是否可用？",
	"serviceCase.proactiveCaseClosure.question.technicalGuideHelpful": "您是否能够借助 Technical Guide 自行解决问题？",
	"serviceCase.proactiveCaseClosure.question.pauseRequest": "您是否想要暂停此类异常的通知？",
	"serviceCase.proactiveCaseClosure.question.pauseRequestDuration": "您想要暂停此类异常通知多长时间？",
	"serviceCase.proactiveCaseClosure.question.comment": "请您说明您想要暂停此类异常通知的原因：",
	"serviceCase.proactiveCaseClosure.question.commentPlaceholder": "为申请案例关闭并提交反馈，评论为必填项",
	"serviceCase.proactiveCaseClosure.answers.yes": "是",
	"serviceCase.proactiveCaseClosure.answers.no": "否",
	"serviceCase.proactiveCaseClosure.answers.sevenDays": "7 天",
	"serviceCase.proactiveCaseClosure.answers.fourteenDays": "14 天",
	"serviceCase.proactiveCaseClosure.answers.thirtyDays": "30 天",
	"serviceCase.proactiveCaseClosure.answers.ninetyDays": "90 天",
	"sisConnector.success.headline": "已成功创建服务案例。",
	"sisConnector.success.orderNumberRequired.title": "提示：",
	"sisConnector.success.orderNumberRequired.text": "请在案例详情页添加订货号，以便案例计费并为您提供其他服务。",
	"sisConnector.success.technicalGuide.title": "没有对应该故障编号的 Technical Guide 可用。",
	"sisConnector.success.technicalGuide.text": "根据输入的故障编号可查到一个或多个 Technical Guide。大约有 50% 的案例你可自行解决问题。该功能只能与对应的服务协议配合使用。",
	"sisConnector.success.outsideOfServiceHours": "请注意，在服务时间之外创建的案例将不会被处理。",
	"sisConnector.success.serviceTimes.MonFri": "我们的服务时间：周一至周五",
	"sisConnector.success.serviceTimes.Sat": "以及周六",
	"sisConnector.success.withTechnicalServiceHotline": "如急需帮助，请致电通快技术服务部（{{hotline}}）获取支持。",
	"sisConnector.success.withoutTechnicalServiceHotline": "如急需帮助，请致电通快技术服务部获取支持。",
	"sisConnector.success.caseId": "案例编号",
	"sisConnector.failed.headline": "无法创建服务案例。",
	"sisConnector.failed.unknownError": "请稍后再试，或者咨询支持人员。"
};
var zhCN = {
	locale: locale,
	translations: translations
};

export { zhCN as default, locale, translations };
//# sourceMappingURL=zh-CN-BDzFAJKf.js.map

//# sourceMappingURL=zh-CN-BDzFAJKf.js.map